
import _moment from 'moment';
import * as momentTimezone from 'moment-timezone';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { EventEmitter, Injectable } from '@angular/core';
import { format, utcToZonedTime } from 'date-fns-tz';
import { DateTime } from 'luxon';
import { ApiService } from './api.service';
import { Router } from '@angular/router';
import { StorageService } from './storage.service';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
const moment = _moment;

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  summaryDownloadInProgress = false;
  sidbarChange: EventEmitter<boolean> = new EventEmitter();
  dropDownChange: EventEmitter<boolean> = new EventEmitter();
  dropDownDisable: EventEmitter<boolean> = new EventEmitter();
  headerUpdate: EventEmitter<boolean> = new EventEmitter();
  headerHide: EventEmitter<boolean> = new EventEmitter();
  newMsgUpdate: EventEmitter<any> = new EventEmitter();
  emailPattern = '^[a-zA-Z0-9]+(.[a-zA-Z0-9]+)*@[a-zA-Z0-9]+(.[a-zA-Z0-9]+)+$';
  passwordPattern =
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d.*)(?=.*\\W.*)[a-zA-Z0-9\\S]{8,}$';
  taxIdPattern = '^\\d{2}-?\\d{7}$';
  cliaPattern = '^[A-Za-z0-9]{10}$';
  medicalLicencePattern = '^[A-Za-z0-9]{2,10}$';
  addressPattern = "^(?!\\s)(?!.*\\s$)[A-Za-z0-9'\\.\\-\\s,()]+$";
  notesPattern = "^(?=.*[A-Za-z0-9])[A-Za-z0-9'\\.\\-\\s,()]+(?<!\\s)$";
  diagnosisNotesPattern =
    /^(?![\s\S]*<\s*\/?\s*script\b)(?![\s\S]*javascript\s*:)(?![\s\S]*\bon\w+\s*=)(?![\s\S]*<\s*\/?\s*[a-z][\w:-]*)[\s\S]*$/i;
  // in CommonService
  patternCptCode = /^(\d{5}|\d{4}[FT])$/;
  patterWithSpace = /^(?!.*<script)(?!.*javascript:)(?!.*on\w+=)[\s\S]*$/i;
  skuPattern = '^[A-Za-z0-9_-]{3,30}$';

  phonePattern = '^\\d{3}-\\d{3}-\\d{4}$';
  feePattern = '^(?!^0*$)(?!^0*\\.0*$)^\\d{0,10}(\\.\\d{1,2})?$';
  zipCodePattern = '^[a-zA-Z0-9]{1,10}$';
  numbersPattern = '^[0-9]*$';
  stringWithNumberAndSpacePattern = '[a-zA-Z0-9 ]*$';
  nameWithSpacePattern = /^[a-zA-Z 0-9'\\-]*$/;
  namePattern = "^[a-zA-Z']*";
  countryPattern = "^[A-Za-z\\s\\-']+$";
  descriptionPattern =
    /^[A-Za-z0-9'"_@./#&+\-\\$*%^()!|\n](?:[ A-Za-z0-9'"_@./#&+\-\\$*%^()!|\n]*[A-Za-z0-9'"_@./#&+\-\\$*%^()!|\n])?$/;
  icdCodePattern = '[A-TV-Z][0-9][0-9AB].?[0-9A-TV-Z]{0,4}';
  npiPattern = '[0-9]{10}';
  numbersAndStringPattern = '[a-zA-Z0-9]*$';
  voyageCodePattern = /^\s*[A-Za-z0-9'-](?:[A-Za-z0-9' -]*[A-Za-z0-9'-])?\s*$/;
  cptCodePattern = '^[A-Za-z0-9]{5}$';
  cptModdifierPattern = '^([a-zA-Z0-9]){2}$';
  decimalNumberPatter = '^(?!0+(\\.0+)?$)\\d{0,5}(.\\d{1,2})?$';
  PTAN = '[0-9]{6}';
  medicaidNumber = '[0-9]{9}';
  cabinNumber = '^[a-zA-Z0-9]+$';
  copay = '[0-9]{2}';
  numberRangePattern = /^([0-9]{1,3})+-([0-9]{1,3})+$/;
  numberPattern = '^[1-9][0-9]{0,10}(?:.[0-9]{1,2})?$';
  nonZero = '^\\s*(?=.*[1-9])\\d*(?:\\.\\d{1,2})?\\s*$';
  heightIncFt = /^\d+('?(\d+\x22)?|\x22)$/;
  feePercentPattern = /^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?)$/;
  zipCodeNew = '^(d{5}|d{9})?$';
  permissions: any;
  urlPattern =
    '^(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$';
  alphanumericWithoutSpacePattern = '[a-zA-Z0-9]+([a-zA-Z0-9]+)*$';


  patientId: any;
  isSideMenuCollapesed: boolean = false;
  matchingTimeZone: any;
  timezoneMapping: any;
  timezone_List = [
    { id: '1', value: 'Eastern Standard Time UTC -05:00' },
    { id: '2', value: 'Central Standard Time UTC -06:00' },
    { id: '3', value: 'Mountain Standard Time UTC -07:00' },
    { id: '4', value: 'Pacific Standard Time UTC -08:00' },
    { id: '5', value: 'Alaskan Standard Time UTC -09:00' },
    { id: '6', value: 'Hawaiian Standard Time UTC -10:00' },
    { id: '7', value: 'Samoa Standard Time UTC -11:00' },
    { id: '8', value: 'Atlantic Standard Time UTC -04:00' },
    { id: '9', value: 'Baker Island Time UTC -12:00' },
    { id: '10', value: 'Niue Time, Samoa Standard Time UTC -11:00' },
    { id: '11', value: 'Hawaii-Aleutian Standard Time UTC -10:00' },
    { id: '12', value: 'Marquesas Islands Time UTC -09:30' },
    { id: '13', value: 'Alaska Standard Time UTC -09:00' },
    { id: '14', value: 'Pacific Standard Time (US & Canada) UTC -08:00' },
    { id: '15', value: 'Mountain Standard Time (US & Canada) UTC -07:00' },
    { id: '19', value: 'Newfoundland Standard Time UTC -03:30' },
    { id: '20', value: 'Argentina, Brazil, Uruguay Time UTC -03:00' },
    {
      id: '21',
      value: 'South Georgia & South Sandwich Islands Time UTC -02:00',
    },
    { id: '22', value: 'Azores, Cape Verde Time UTC -01:00' },
    {
      id: '23',
      value: 'Greenwich Mean Time (GMT), Western Europe Time UTC 00:00',
    },
    { id: '24', value: 'Central European Time, West Africa Time UTC +01:00' },
    {
      id: '25',
      value: 'Eastern European Time, Central Africa Time UTC +02:00',
    },
    { id: '26', value: 'East Africa Time, Arabia Standard Time UTC +03:00' },
    { id: '27', value: 'Iran Standard Time UTC +03:30' },
    { id: '28', value: 'Gulf Standard Time, Samara Time UTC +04:00' },
    { id: '29', value: 'Afghanistan Time UTC +04:30' },
    {
      id: '30',
      value: 'Pakistan Standard Time, Yekaterinburg Time UTC +05:00',
    },
    { id: '31', value: 'Indian Standard Time, Sri Lanka Time UTC +05:30' },
    { id: '32', value: 'Nepal Standard Time UTC +05:45' },
    { id: '33', value: 'Bangladesh Time, Bhutan Time UTC +06:00' },
    { id: '34', value: 'Cocos Islands Time, Myanmar Time UTC +06:30' },
    {
      id: '35',
      value: 'Indochina Time (Thailand, Vietnam, Cambodia) UTC +07:00',
    },
    {
      id: '36',
      value: 'China Standard Time, Western Australia Time UTC +08:00',
    },
    { id: '37', value: 'Southeastern Western Australia Time UTC +08:45' },
    { id: '38', value: 'Japan Standard Time, Korea Standard Time UTC +09:00' },
    { id: '39', value: 'Central Australia Time UTC +09:30' },
    { id: '40', value: 'Eastern Australia Time, Vladivostok Time UTC +10:00' },
    { id: '41', value: 'Lord Howe Island Time UTC +10:30' },
    { id: '42', value: 'Solomon Islands Time, Magadan Time UTC +11:00' },
    { id: '43', value: 'New Zealand Standard Time, Fiji Time UTC +12:00' },

    { id: '44', value: 'Chatham Islands Time UTC +12:45' },
    { id: '45', value: 'Tonga Time, Phoenix Islands Time UTC +13:00' },
    { id: '46', value: 'Line Islands Time UTC +14:00' },
  ];

  getTimeZoneAbbreviation(name: string): string {
    const exceptions: { [key: string]: string } = {
      'Eastern Standard Time': 'EST',
      'Central Standard Time': 'CST',
      'Mountain Standard Time': 'MST',
      'Pacific Standard Time': 'PST',
      'Alaskan Standard Time': 'AKST',
      'Hawaiian Standard Time': 'HST',
      'Samoa Standard Time': 'SST',
      'Atlantic Standard Time': 'AST',
      'Baker Island Time': 'BIT',
      'Niue Time, Samoa Standard Time': 'NUT',
      'Hawaii-Aleutian Standard Time': 'HAST',
      'Marquesas Islands Time': 'MIT',
      'Alaska Standard Time': 'AKST',
      'Pacific Standard Time (US & Canada)': 'PST',
      'Mountain Standard Time (US & Canada)': 'MST',
      'Newfoundland Standard Time': 'NST',
      'Argentina, Brazil, Uruguay Time': 'ART',
      'South Georgia & South Sandwich Islands Time': 'GST',
      'Azores, Cape Verde Time': 'AZOT',
      'Greenwich Mean Time (GMT), Western Europe Time': 'GMT',
      'Central European Time, West Africa Time': 'CET',
      'Eastern European Time, Central Africa Time': 'EET',
      'East Africa Time, Arabia Standard Time': 'EAT',
      'Iran Standard Time': 'IRST',
      'Gulf Standard Time, Samara Time': 'GST',
      'Afghanistan Time': 'AFT',
      'Pakistan Standard Time, Yekaterinburg Time': 'PKT',
      'Indian Standard Time, Sri Lanka Time': 'IST',
      'Nepal Standard Time': 'NPT',
      'Bangladesh Time, Bhutan Time': 'BST',
      'Cocos Islands Time, Myanmar Time': 'MMT',
      'Indochina Time (Thailand, Vietnam, Cambodia)': 'ICT',
      'China Standard Time, Western Australia Time': 'CST',
      'Southeastern Western Australia Time': 'ACWST',
      'Japan Standard Time, Korea Standard Time': 'JST',
      'Central Australia Time': 'ACST',
      'Eastern Australia Time, Vladivostok Time': 'AEST',
      'Lord Howe Island Time': 'LHST',
      'Solomon Islands Time, Magadan Time': 'SBT',
      'New Zealand Standard Time, Fiji Time': 'NZST',
      'Chatham Islands Time': 'CHAST',
      'Tonga Time, Phoenix Islands Time': 'TOT',
      'Line Islands Time': 'LINT',
    };

    return exceptions[name] || '';
  }
  timezoneMap: { [key: string]: string } = {
    'Eastern Standard Time UTC -05:00': 'America/New_York',
    'Central Standard Time UTC -06:00': 'America/Chicago',
    'Mountain Standard Time UTC -07:00': 'America/Denver',
    'Pacific Standard Time UTC -08:00': 'America/Los_Angeles',
    'Alaskan Standard Time UTC -09:00': 'America/Anchorage',
    'Hawaiian Standard Time UTC -10:00': 'Pacific/Honolulu',
    'Samoa Standard Time UTC -11:00': 'Pacific/Pago_Pago',
    'Atlantic Standard Time UTC -04:00': 'America/Puerto_Rico',
    'Baker Island Time UTC -12:00': 'Etc/GMT+12',
    'Niue Time, Samoa Standard Time UTC -11:00': 'Pacific/Niue',
    'Hawaii-Aleutian Standard Time UTC -10:00': 'Pacific/Honolulu',
    'Marquesas Islands Time UTC -09:30': 'Pacific/Marquesas',
    'Alaska Standard Time UTC -09:00': 'America/Anchorage',
    'Pacific Standard Time (US & Canada) UTC -08:00': 'America/Los_Angeles',
    'Mountain Standard Time (US & Canada) UTC -07:00': 'America/Denver',
    'Newfoundland Standard Time UTC -03:30': 'America/St_Johns',
    'Argentina, Brazil, Uruguay Time UTC -03:00': 'America/Argentina/Buenos_Aires',
    'South Georgia & South Sandwich Islands Time UTC -02:00': 'Atlantic/South_Georgia',
    'Azores, Cape Verde Time UTC -01:00': 'Atlantic/Azores',
    'Greenwich Mean Time (GMT), Western Europe Time UTC 00:00': 'Europe/London',
    'Central European Time, West Africa Time UTC +01:00': 'Europe/Paris',
    'Eastern European Time, Central Africa Time UTC +02:00': 'Europe/Bucharest',
    'East Africa Time, Arabia Standard Time UTC +03:00': 'Africa/Nairobi',
    'Iran Standard Time UTC +03:30': 'Asia/Tehran',
    'Gulf Standard Time, Samara Time UTC +04:00': 'Asia/Dubai',
    'Afghanistan Time UTC +04:30': 'Asia/Kabul',
    'Pakistan Standard Time, Yekaterinburg Time UTC +05:00': 'Asia/Karachi',
    'Indian Standard Time, Sri Lanka Time UTC +05:30': 'Asia/Kolkata',
    'Nepal Standard Time UTC +05:45': 'Asia/Kathmandu',
    'Bangladesh Time, Bhutan Time UTC +06:00': 'Asia/Dhaka',
    'Cocos Islands Time, Myanmar Time UTC +06:30': 'Indian/Cocos',
    'Indochina Time (Thailand, Vietnam, Cambodia) UTC +07:00': 'Asia/Bangkok',
    'China Standard Time, Western Australia Time UTC +08:00': 'Asia/Shanghai',
    'Southeastern Western Australia Time UTC +08:45': 'Australia/Eucla',
    'Japan Standard Time, Korea Standard Time UTC +09:00': 'Asia/Tokyo',
    'Central Australia Time UTC +09:30': 'Australia/Adelaide',
    'Eastern Australia Time, Vladivostok Time UTC +10:00': 'Australia/Sydney',
    'Lord Howe Island Time UTC +10:30': 'Australia/Lord_Howe',
    'Solomon Islands Time, Magadan Time UTC +11:00': 'Pacific/Guadalcanal',
    'New Zealand Standard Time, Fiji Time UTC +12:00': 'Pacific/Auckland',
    'Chatham Islands Time UTC +12:45': 'Pacific/Chatham',
    'Tonga Time, Phoenix Islands Time UTC +13:00': 'Pacific/Tongatapu',
    'Line Islands Time UTC +14:00': 'Pacific/Kiritimati',
  };

  getTimeZoneFullName(abbreviation: string): string {
    const exceptions: { [key: string]: string } = {
      EST: 'Eastern Standard Time',
      CST: 'Central Standard Time',
      MST: 'Mountain Standard Time',
      PST: 'Pacific Standard Time',
      AKST: 'Alaskan Standard Time',
      HST: 'Hawaiian Standard Time',
      SST: 'Samoa Standard Time',
      AST: 'Atlantic Standard Time',
      BIT: 'Baker Island Time',
      NUT: 'Niue Time, Samoa Standard Time',
      HAST: 'Hawaii-Aleutian Standard Time',
      MIT: 'Marquesas Islands Time',
      NST: 'Newfoundland Standard Time',
      ART: 'Argentina, Brazil, Uruguay Time',
      AZOT: 'Azores, Cape Verde Time',
      GMT: 'Greenwich Mean Time (GMT), Western Europe Time',
      CET: 'Central European Time, West Africa Time',
      EET: 'Eastern European Time, Central Africa Time',
      EAT: 'East Africa Time, Arabia Standard Time',
      IRST: 'Iran Standard Time',
      AFT: 'Afghanistan Time',
      PKT: 'Pakistan Standard Time, Yekaterinburg Time',
      IST: 'Indian Standard Time, Sri Lanka Time',
      NPT: 'Nepal Standard Time',
      BST: 'Bangladesh Time, Bhutan Time',
      MMT: 'Cocos Islands Time, Myanmar Time',
      ICT: 'Indochina Time (Thailand, Vietnam, Cambodia)',
      ACWST: 'Southeastern Western Australia Time',
      JST: 'Japan Standard Time, Korea Standard Time',
      ACST: 'Central Australia Time',
      AEST: 'Eastern Australia Time, Vladivostok Time',
      LHST: 'Lord Howe Island Time',
      SBT: 'Solomon Islands Time, Magadan Time',
      NZST: 'New Zealand Standard Time, Fiji Time',
      CHAST: 'Chatham Islands Time',
      TOT: 'Tonga Time, Phoenix Islands Time',
      LINT: 'Line Islands Time',
    };

    return exceptions[abbreviation] || '';
  }

  getTimeZoneValueById(id: string) {
    const match = this.timezone_List?.find((z) => +z.id === +id);
    return match?.value;
  }

  getIanaZoneFromDisplayName(displayName: string): string | undefined {
    return this.timezoneMap[displayName];
  }

  convertAppointmentTimeRange(appointment: any): string {
    const profileDisplayName = this.storageService.get('Timezone');
    const profileTimeZone = this.getIanaZoneFromDisplayName(profileDisplayName);
    const timezoneId = appointment.timeZoneId
      ? appointment.timeZoneId.toString()
      : appointment.timezoneId;
    const timeZoneDisplay = this.getTimeZoneValueById(timezoneId);
    const tzAbbr = DateTime.now()
      .setZone(profileTimeZone)
      .offsetNameShort;
    const ianaTimeZone = this.getIanaZoneFromDisplayName(timeZoneDisplay);
    if (!ianaTimeZone) return '-';
    const dateStr = appointment.appointmentDate?.split('T')[0];
    if (!dateStr || !appointment.startTime || !appointment.endTime) return '-';
    const getDateTime = (time: string) => {
      if (/AM|PM/i.test(time)) {
        return DateTime.fromFormat(`${dateStr} ${time}`, 'yyyy-MM-dd h:mm a', {
          zone: ianaTimeZone,
        });
      } else {
        return DateTime.fromFormat(
          `${dateStr} ${time}`,
          'yyyy-MM-dd HH:mm:ss',
          { zone: ianaTimeZone }
        );
      }
    };

    const start = getDateTime(appointment.startTime);
    const end = getDateTime(appointment.endTime);

    if (!start.isValid || !end.isValid) return '-';

    const startConverted = start.setZone(profileTimeZone);
    const endConverted = end.setZone(profileTimeZone);

    const formattedDate = startConverted.toFormat('MM/dd/yyyy');
    const formattedTimeRange = `${startConverted.toFormat(
      'hh:mm a'
    )} - ${endConverted.toFormat('hh:mm a')}`;

    return `${formattedDate} | ${formattedTimeRange} (${tzAbbr})`;
  }

  isJoinable(appointment: any): boolean {
    const profileDisplayName = this.storageService.get('Timezone');
    const profileTimeZone = this.getIanaZoneFromDisplayName(profileDisplayName);

    const dateStr = appointment.appointmentDate?.split('T')[0];
    if (!dateStr || !appointment.startTime) return false;

    const getDateTime = (time: string) => {
      if (/AM|PM/i.test(time)) {
        return DateTime.fromFormat(`${dateStr} ${time}`, 'yyyy-MM-dd h:mm a', {
          zone: profileTimeZone,
        });
      } else {
        return DateTime.fromFormat(
          `${dateStr} ${time}`,
          'yyyy-MM-dd HH:mm:ss',
          { zone: profileTimeZone }
        );
      }
    };

    const start = getDateTime(appointment.startTime);
    if (!start.isValid) return false;

    const now = DateTime.now().setZone(profileTimeZone);
    return (
      now >= start.minus({ minutes: 15 }) && now <= start.plus({ minutes: 60 })
    );
  }

  constructor(
    public readonly router: Router,
    public readonly apiService: ApiService,
    public readonly storageService: StorageService,
    private readonly toastr: ToastrService,
    private readonly modalService: NgbModal,
  ) {
    const ended = this.readVoyageEndedFlag() || !this.hasActiveVoyage();
    this.voyageEndedSubject.next(ended);
    document.body.classList.toggle('voyage-ended', ended);
  }

  emitsidbarChangeEvent(number: boolean) {
    this.sidbarChange.emit(number);
  }

  emitdropDownChangeEvent(number: boolean) {
    this.dropDownChange.emit(number);
  }
  emitdropDownDisableEvent(number: boolean) {
    this.dropDownDisable.emit(number);
  }

  private  readonly sidebarState = new BehaviorSubject<{ collapsed: boolean; mobileOpen: boolean }>({
    collapsed: false,
    mobileOpen: false
  });
  sidebarState$ = this.sidebarState.asObservable();


  setSideMenuValue(value: boolean) {
    this.isSideMenuCollapesed = value;
    this.sidebarState.next({ ...this.sidebarState.value, collapsed: value });
  }

  getSideMenuCollapsedValue() {
    return this.isSideMenuCollapesed;
  }

  setMobileSidebarOpen(open: boolean) {
    this.sidebarState.next({ ...this.sidebarState.value, mobileOpen: open });
  }

  getMobileSidebarOpen(): boolean {
    return this.sidebarState.value.mobileOpen;
  }

  toggleSidebar() {
    const isMobile = window.innerWidth <= 767;
    if (isMobile) {
      this.setMobileSidebarOpen(!this.getMobileSidebarOpen());
    } else {
      this.setSideMenuValue(!this.isSideMenuCollapesed);
    }
  }

  closeMobileSidebar() {
    this.setMobileSidebarOpen(false);
  }



  emitHeaderUpdate(data: any) {
    this.headerUpdate.emit(data);
  }
  emitnewMsgUpdateEvent(data?: any) {
    this.newMsgUpdate.emit(data);
  }
  emitHeaderHide(data: any) {
    this.headerHide.emit(data);
  }

  public noWhitespaceValidator(control: FormControl) {
    let isWhitespace = (control.value || '').trim().length === 0;
    let isValid = !isWhitespace;
    return isValid ? null : { required: true };
  }

  logout() {
    this.modalService.dismissAll();
    this.toastr.warning('Session timed out. Please log in again.', 'Warning!', {
      timeOut: 5000,
    });
    this.storageService.clear();
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }

  setPermissions() {
    const raw = this.storageService.get('permissions');
    this.permissions = typeof raw === 'string' ? JSON.parse(raw) : raw;
  }

  isVoyageEnded(): boolean {
    return this.voyageEndedSubject.value;
  }

  /** True when ActiveVoyage API/storage has at least one voyage. */
  hasActiveVoyage(voyage: any = this.storageService.get('ActiveVoyage')): boolean {
    if (voyage == null || voyage === '' || voyage === 'null' || voyage === 'undefined') {
      return false;
    }
    if (Array.isArray(voyage)) {
      return voyage.length > 0 && this.hasActiveVoyage(voyage[0]);
    }
    if (typeof voyage === 'object') {
      return voyage.id != null && voyage.id !== '';
    }
    return false;
  }

  setVoyageEnded(ended: boolean): void {
    this.storageService.set('voyageended', ended);
    this.voyageEndedSubject.next(!!ended);
    document.body.classList.toggle('voyage-ended', !!ended);
  }

  private readVoyageEndedFlag(): boolean {
    const flag = this.storageService.get('voyageended');
    return flag === true || flag === 'true' || flag === 1 || flag === '1';
  }

  isSuperAdmin(role: string = this.storageService.get('role')): boolean {
    return String(role || '').trim().toLowerCase() === 'super admin';
  }

  getPermissions() {
    const permissions = this.readPermissions();
    return this.isSuperAdmin() ? this.grantAllPermissions(permissions) : permissions;
  }

  /** True when this module itself has view or all. Child grants do not open the parent menu. */
  hasModuleTreeAccess(moduleName: string, modules: any[] = this.readPermissions()): boolean {
    if (this.isSuperAdmin()) {
      return true;
    }
    return this.moduleTreeAllows(moduleName, modules);
  }

  /** True when this module itself has the given flag, or all. */
  hasModuleFlag(
    moduleName: string,
    flag: 'isView' | 'isAdd' | 'isEdit' | 'isDelete' | 'isDownload',
    modules: any[] = this.readPermissions()
  ): boolean {
    if (this.isSuperAdmin()) {
      return true;
    }
    return this.moduleHasFlag(moduleName, flag, modules);
  }

  /** True when this node or any child has view or all. */
  hasAnyGrantedPermission(module: any): boolean {
    if (this.isSuperAdmin()) {
      return true;
    }
    return this.selfOrDescendantGranted(module);
  }

  private readPermissions(): any[] {
    const raw = this.storageService.get('permissions');

    if (!raw) {
      return [];
    }

    try {
      const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error('Invalid permissions data:', raw, error);
      return [];
    }
  }

  private grantAllPermissions(modules: any[]): any[] {
    return (modules || []).map((module) => ({
      ...module,
      isAll: true,
      isView: true,
      isAdd: true,
      isEdit: true,
      isDelete: true,
      isDownload: true,
      isActivate: true,
      sub: this.grantAllPermissions(module?.sub || []),
    }));
  }

  private moduleHasFlag(moduleName: string, flag: string, modules: any[]): boolean {
    const target = String(moduleName || '').trim().toLowerCase();
    for (const module of modules || []) {
      const name = String(module?.module || '').trim().toLowerCase();
      if (name === target) {
        return !!(module?.[flag] || module?.isAll);
      }
      if (this.moduleHasFlag(moduleName, flag, module?.sub || [])) {
        return true;
      }
    }
    return false;
  }

  private moduleTreeAllows(moduleName: string, modules: any[]): boolean {
    const target = String(moduleName || '').trim().toLowerCase();
    for (const module of modules || []) {
      const name = String(module?.module || '').trim().toLowerCase();
      if (name === target) {
        return !!(module?.isView || module?.isAll);
      }
      if (this.moduleTreeAllows(moduleName, module?.sub || [])) {
        return true;
      }
    }
    return false;
  }

  private selfOrDescendantGranted(module: any): boolean {
    if (!module) {
      return false;
    }
    if (module.isView || module.isAll) {
      return true;
    }
    return (module.sub || []).some((child: any) => this.selfOrDescendantGranted(child));
  }
  formatDateTime(date: any): string {
    return date
      ? moment(date).format('MM-DD-YYYY hh:mm a')
      : '';
  }
  showErrorToast(msg: any): void {
  this.toastr.error(msg);
}

showSuccessToast(msg: any): void {
  this.toastr.success(msg);
}
  matchingPasswords(passwordKey: string, confirmPasswordKey: string) {
    return (group: FormGroup): any => {
      let password = group.controls[passwordKey];
      let confirmPassword = group.controls[confirmPasswordKey];

      if (password.value !== confirmPassword.value) {
        confirmPassword.setErrors({
          mismatchedPasswords: true,
        });
      } else {
        confirmPassword.setErrors(null);
      }
    };
  }

  base64ToBlob(dataURI: any) {
    const byteString = atob(dataURI.toString().split(',')[1]);
    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    let blob = new Blob([ab], { type: 'image/png' });
    let image = new File(
      [blob],
      'Logo_' + new Date().getMilliseconds() + '.png'
    );

    return image;
  }

  rangeShouldNotBeSame(key1: string, key2: string) {
    return (group: FormGroup): any => {
      let key1Control = group.controls[key1];
      let key2Control = group.controls[key2];
      if (
        JSON.stringify(key1Control.value) == JSON.stringify(key2Control.value)
      ) {
        return {
          areSame: true,
        };
      }
      return null;
    };
  }
  parseTime(timeStr: string): Date | null {
    if (!timeStr) return null;

    // Extract hours, minutes, and AM/PM
    const timeParts = timeStr?.split(/[\s:]+/);
    let hours = parseInt(timeParts[0]);
    const minutes = parseInt(timeParts[1]);
    const meridian = timeParts[2]?.toUpperCase();

    // Adjust hours for PM times
    if (meridian === 'PM' && hours < 12) {
      hours += 12;
    }

    // Handle midnight (12:00 AM) case
    if (hours === 12 && meridian === 'AM') {
      hours = 0;
    }

    // Create a new date with today's date and the adjusted time
    const currentDate = new Date();
    currentDate.setHours(hours, minutes, 0, 0);

    return currentDate;
  }
  timeRangeValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const startTime = this.parseTime(control.get('startTime')?.value);
      const endTime = this.parseTime(control.get('endTime')?.value);

      if (startTime && endTime && startTime >= endTime) {
        return { invalidTimeRange: true };
      }
      return null;
    };
  }

  public ContactDuplicateValidator(control: FormGroup) {
    if (!control) return true;

    const normalize = (val: string) => val?.replace(/[-_]/g, '') || '';

    const getValue = (field: string) =>
      normalize(control.value?.[field] ?? control.get(field)?.value);

    const WorkPhone = getValue('WorkPhone');
    const WorkFax = getValue('WorkFax');
    const WorkPager = getValue('WorkPager');
    const WorkMobile = getValue('WorkMobile');
    const ProviderPhone = getValue('phone');
    const ProviderFax = getValue('fax');

    const checkDuplicate = (
      value: string,
      matches: string[],
      errorKey: string
    ) => (value && matches.includes(value) ? { [errorKey]: true } : null);

    return (
      checkDuplicate(
        WorkMobile,
        [WorkPhone, WorkFax, WorkPager],
        'duplicateMobile'
      ) ||
      checkDuplicate(WorkPager, [WorkFax, WorkPhone], 'duplicatePager') ||
      checkDuplicate(WorkFax, [WorkPhone], 'duplicateFax') ||
      checkDuplicate(ProviderFax, [ProviderPhone], 'duplicateFax')
    );
  }

  hasExtension(file: any, exts: any) {
    let fileName = file?.name.toLowerCase();
    return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
      fileName
    );
  }

  localToUtc(
    date: any,
    format: any = 'MM/DD/YYYY hh:mm a',
    newtimeZone: any = null,
    returnFormat: any = 'MM/DD/YYYY HH:mm'
  ) {
    let timezone = moment.tz.guess();
    timezone = newtimeZone ? newtimeZone : timezone;
    return moment.tz(date, format, timezone).utc().format(returnFormat);
  }

  utcToLocal(
    date: any,
    format: any,
    displayFormat: any = 'MM/DD/YYYY hh:mm a',
    newtimeZone: any = null
  ) {
    let timezone = moment.tz.guess();

    timezone = newtimeZone ? newtimeZone : timezone;

    return momentTimezone.utc(date, format).tz(timezone).format(displayFormat);
  }

  getDates(startDate, stopDate) {
    let dateArray = [];
    let currentDate = moment(startDate, 'MM/DD/YYYY');
    let endDate = moment(stopDate, 'MM/DD/YYYY');
    while (currentDate <= endDate) {
      dateArray.push(moment(currentDate).format('MM/DD/YYYY'));
      currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
  }

  getMonths() {
    let m = moment();
    let array = [];
    for (let i = 0; i < 12; i++) {
      array.push({
        id: m.month(i).format('MMMM'),
        value: m.month(i).format('MMMM[, ]Y'),
      });
    }

    return array;
  }

  getMonthsPastYears() {
    let startDate = moment().subtract(2, 'years');
    let endDate = moment();
    let array = [];

    if (startDate < endDate) {
      let date = startDate.startOf('month');

      while (date < endDate.endOf('month')) {
        array.push({
          id: date.format('MMMM[, ]Y'),
          value: date.format('MMMM[, ]Y'),
        });
        date.add(1, 'month');
      }
    }

    return array.reverse();
  }

  getAge(date) {
    return moment().diff(moment(date, 'MM-DD-YYYY'), 'years');
  }

  getOffset(timeZone: string): number {
    return DateTime.now().setZone(timeZone).offset / 60;
  }


  convertUtcToTimezone(utc: string) {

    if (!utc) return '';

    let normalizedUtc = utc?.trim();

    if (normalizedUtc.includes('/') && normalizedUtc.includes(':')) {
      const [datePart, timePart] = normalizedUtc.split(' ');
      const [p1, p2, year] = datePart.split('/').map(Number);

      let day: number;
      let month: number;
      if (p1 > 12) {
        day = p1;
        month = p2;
      } else {
        month = p1;
        day = p2;
      }

      normalizedUtc = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${timePart}`;
    }

    // ✅ Ensure UTC
    if (!normalizedUtc.includes('Z') && !normalizedUtc.includes('+')) {
      normalizedUtc += 'Z';
    }

    const utcDate = new Date(normalizedUtc);
    if (isNaN(utcDate.getTime())) return '';

    const timeZoneString = this.storageService.get('Timezone');
    const timeZoneValue = this.timezoneMap[timeZoneString];
    if (!timeZoneValue) return '';

    const zonedDate = utcToZonedTime(utcDate, timeZoneValue);

    // ✅ Format exactly: Jan 12, 2026 19:44
    const formattedDate = format(zonedDate, 'MMM dd, yyyy HH:mm', {
      timeZone: timeZoneValue,
    });

    // ✅ Append UTC offset
    const offset = DateTime.fromJSDate(utcDate)
      .setZone(timeZoneValue)
      .toFormat('ZZ');

    return `${formattedDate} UTC ${offset}`;
  }




  convertUtcTimeToTimezone(time: string) {
    let timeZone = this.storageService.get('Timezone');
    const timeZoneValue = this.timezoneMap[timeZone];

    if (time) {
      let utcDate;
      let date = new Date();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate() - 1).padStart(2, '0');

      const year = date.getFullYear();

      utcDate = `${year}-${month}-${day}`;
      utcDate = utcDate + 'T' + time + 'Z';
      const zonedDate = utcToZonedTime(utcDate, timeZoneValue);
      const formattedDate = format(zonedDate, 'MM-dd-yyyy HH:mm', {
        timeZone: timeZoneValue,
      });
      time = formattedDate.split(' ')[1];

      let [hour, minute] = time.split(':').map(Number);
      let period = hour >= 12 ? 'PM' : 'AM';
      hour = hour % 12 || 12;
      return `${hour}:${minute.toString().padStart(2, '0')} ${period}`;
    } else {
      return '';
    }
  }

  trimControls(form: FormGroup, controlNames: string[]) {
    controlNames.forEach((name) => {
      const ctrl = form.get(name);
      if (ctrl && typeof ctrl.value === 'string') {
        ctrl.setValue(ctrl.value.trim());
      }
    });
  }

  private readonly encounterCloseSubject = new BehaviorSubject<boolean>(false);
  encounterClose$ = this.encounterCloseSubject.asObservable();

  setEncounterClose(value: boolean): void {
    this.encounterCloseSubject.next(value);
  }

  getEncounterClose(): boolean {
    return this.encounterCloseSubject.value;
  }

  //For pending order count
  private readonly orderRefreshSource = new Subject<void>();

  orderRefresh$ = this.orderRefreshSource.asObservable();

  triggerOrderRefresh() {
    this.orderRefreshSource.next();
  }
  trimStringValues(obj: any): any {
    if (obj === null || obj === undefined) return obj;

    if (typeof obj === 'string') {
      return obj.trim();
    }

    if (Array.isArray(obj)) {
      return obj.map((item) => this.trimStringValues(item));
    }

    if (typeof obj === 'object') {
      const trimmedObj: any = {};
      Object.keys(obj).forEach((key) => {
        trimmedObj[key] = this.trimStringValues(obj[key]);
      });
      return trimmedObj;
    }

    return obj;
  }

  //For global company selection
  private readonly selectedCompanySubject = new BehaviorSubject<any[]>([]);

  selectedCompany$ = this.selectedCompanySubject.asObservable();

  setSelectedCompany(companyIds: any[]) {
    this.selectedCompanySubject.next(companyIds);
  }

  getSelectedCompany() {
    return this.selectedCompanySubject.value;
  }

  private readonly companyRefreshSubject = new Subject<void>();
  companyRefresh$ = this.companyRefreshSubject.asObservable();

  refreshCompanyList() {
    this.companyRefreshSubject.next();
  }

  private readonly voyageRefreshSubject = new Subject<{
    voyageId?: string | number | null;
    startDate?: string | null;
    endDate?: string | null;
  } | undefined>();
  voyageRefresh$ = this.voyageRefreshSubject.asObservable();
  private readonly voyageEndedSubject = new BehaviorSubject<boolean>(false);
  voyageEnded$ = this.voyageEndedSubject.asObservable();

  refreshVoyage(update?: {
    voyageId?: string | number | null;
    startDate?: string | null;
    endDate?: string | null;
  }) {
    this.voyageRefreshSubject.next(update);
  }

  prepareGroupedList(activeList: any[], inactiveList: any[]) {

    const active = (activeList || []).map((x: any) => ({
      ...x,
      group: 'Active'
    }));

    const inactive = (inactiveList || []).map((x: any) => ({
      ...x,
      group: 'InActive'
    }));

    return [
      ...active,
      ...inactive
    ];
  }

  requiredHtmlValidator(control: AbstractControl): ValidationErrors | null {
    const value: string = control.value || '';
    const stripped = value.replace(/<[^>]*>/g, '').trim();
    return stripped.length > 0 ? null : { required: true };
  }


}
